window.coreDepositSync = async function(cartData = null) {

  const cart = cartData || await fetch('/cart.js').then(r => r.json());

  const parents = {};
  const deposits = {};
  let changed = false;

  cart.items.forEach(item => {
    if (item.properties && item.properties._core_deposit === "yes") {
      deposits[item.properties._linked_variant] = item;
    } else {
      parents[item.variant_id] = item;
    }
  });

  for (const variant in parents) {

    const parent = parents[variant];
    const deposit = deposits[variant];

    if (!deposit) continue;

    if (parent.quantity !== deposit.quantity) {

      changed = true;

      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          id: deposit.key,
          quantity: parent.quantity
        })
      });
    }
  }

  /* ---------- THE IMPORTANT PART ---------- */

  if (changed) {

    // CART PAGE RE-RENDER
    const cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.onCartUpdate) {
      cartItems.onCartUpdate();
    }

    // CART DRAWER RE-RENDER
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
    }

        setTimeout(() => {
    location.reload();
    }, 500);
  }
};

/* ===== REMOVE LINK INTERCEPTOR ===== */

document.addEventListener('click', async function(e) {

  const removeLink = e.target.closest('a[href*="/cart/change"]');
  if (!removeLink) return;

  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) return;

  e.preventDefault();

  try {

    // Get current cart
    const cart = await fetch('/cart.js').then(r => r.json());

    // Extract line key from URL
    const url = new URL(removeLink.href);
    const idParam = url.searchParams.get('id');
    if (!idParam) {
      window.location.href = removeLink.href;
      return;
    }

    const lineKey = idParam.split(':')[0];

    // Find the product being removed
    let removedItem = null;
    cart.items.forEach(item => {
      if (item.key.startsWith(lineKey)) removedItem = item;
    });

    if (!removedItem) {
      window.location.href = removeLink.href;
      return;
    }

    const variantId = removedItem.variant_id;

    // Find linked deposit
    const depositItem = cart.items.find(item =>
      item.properties &&
      item.properties._core_deposit === "yes" &&
      String(item.properties._linked_variant) === String(variantId)
    );

    // Remove main product
    await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        id: removedItem.key,
        quantity:0
      })
    });

    // Remove deposit too
    if (depositItem) {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          id: depositItem.key,
          quantity:0
        })
      });
    }

    // reload cart page
    location.reload();

  } catch(err) {
    console.error('Remove sync failed', err);
    location.href = removeLink.href;
  }
});